//NAR OPERATOR
const ru_NAR = {
  yes: 'Да',
  no: 'Нет',
  no_thanks: 'Нет, спасибо',
  loading: 'Загрузка...',
  global_error: 'Простите, сайт недоступен по техническим причинам. Попробуйте позже',
  email: 'Номер телефона',
  password: 'Пароль',
  close: 'Закрыть',
  favorites: 'Избранное',
  search: 'Поиск',
  related: 'Похожие',
  tv: 'ТВ Каналы',
  movies: 'Фильмы',
  tvseries: 'ТВ Сериалы',
  on_now: 'Гид',
  cartoons: 'Мультфильмы',
  purchases: 'Покупки',
  premiere: 'Премьеры',
  my_services: {
    my_services: 'Мои Сервисы',
    my_rents: 'Мои покупки',
    my_subscriptions: 'Мои подписки',
    subscriptions: 'Подпишись',
    rents: 'Прокат'
  },
  page: {
    home: 'Главная',
    epg: 'Гид',
    favorites: 'Избранное',
    notifications: 'Оповещения',
    records: 'Мои Записи',
    purchases: 'Мои Покупки',
    related: 'Похожие',
    search: 'Поиск',
    collection: 'Категория'
  },
  error: {
    invalid_credentials: 'Неверный логин или пароль',
    invalid_credentials_description: ' ',
    blocked_subscription: ' В данный момент ваша подписка недоступна. Пожалуйста, пополните счет для активации сервисов.',
    'invalid old password': 'Некорректный текущий пароль',
    'passwords mismatch': 'Пароли не совпадают',
    'username field empty': 'Пожалуйста впишите ваш номер телефона',
    'invalid subscriber nar msisdn': 'This phone number does not exist',
    'already registered': 'Данный телефон уже зарегистрирован. Пожалуйста авторизируйтесь или зарегистрируйтесь с другим адресом.',
    'code field empty': 'Пожалуйста введите код из SMS',
    'password field empty': 'Пожалуйста введите ваш пароль.',
    'password too short': 'Длина пароля должна быть больше 6 символов. Вы можете использовать буквы, цифры и специальные символы',
    'invalid password reset code': 'Неверный код подтверждения',
    'invalid ack': 'Неверный код подтверждения',
    'invalid pin': 'Неверный ПИН-код',
    'invalid registration code': 'Неверный код подтверждения из SMS',
  },
  registration: {
    texts: {
      button: 'Создать аккаунт',
      title: 'Зарегистрируйся',
      description: 'Для использования сервисов, пожалуйста, зарегистрируйтесь.'
    }
  },
  login: {
    login: 'Номер телефона',
    login_example: '+994xxxxxxxxx',
    lost_your_password: 'Забыли пароль?',
    logout: 'Выйти',
    log_in: 'Войти'
  },
  forgot_password: {
    login: 'Номер телефона',
    login_example: '+994xxxxxxxxx',
    lost_your_password: 'Забыли пароль?',
    forgot_password: 'Забыли пароль?',
    send: "Отправить",
    recovery_password: "Восстановить пароль",
    empty_field: "Пустое поле",
    wrong_email: "Неверный Номер телефона",
    reset_password_success_message: "Вы получите электронное письмо со ссылкой для сброса пароля",
    reset_password_error_message: "Некорректные данные",
  },
  profile: {
    movie: {
      bundle: 'Подписка',
      min: 'мин',
      fav_add: 'Добавить в избранное',
      fav_remove: 'Убрать из избранного',
      trailer: 'Трейлер',
      youtube_trailer: 'Youtube Трейлер',
      multiscreen: 'Продолжить на другом устройстве',
      related: 'Похожие',
      share: 'Поделиться',
      select_screen: 'Выбрать экран'
    },
    tvSeries: {
      bundle: 'Подписка',
      min: 'мин',
      fav_add: 'Добавить в избранное',
      fav_remove: 'Убрать из избранного',
      trailer: 'Трейлер',
      multiscreen: 'Продолжить на другом устройстве',
      related: 'Похожие',
      share: 'Поделиться',
      select_screen: 'Выбрать экран',
      seasons: 'Сезон',
      episodes: 'Эпизод',
      season_short: 'С', //S01E12
      episode_short: 'Э.', //S01E12
    },
    channel: {
      calendar: {
        before: 'Предидущий',
        previously: 'Ранее',
        now: 'Сейчас',
        after: 'Затем',
        hereafter: 'Позже',
        yesterday: 'Завтра',
        yesterday_at: 'Завтра в',
        today: 'Сегодня',
        today_at: 'Сегодня в',
        tomorrow: 'Завтра',
        tomorrow_at: 'Завтра в',
        last: 'Продолжительность'
      },
      epg: 'TВ Гид',
      bundle: 'Подписка',
      min: 'min',
      fav_add: 'Добавить в избранное',
      fav_remove: 'Убрать из избранного',
      record_add: 'Добавить в Запись',
      record_remove: 'Удалить из Записи',
      schedule_remove: 'Отменить Запись',
      multiscreen: 'Продолжить на другом устройстве',
      share: 'Поделиться',
      select_screen: 'Выбрать экран'
    },
    subscription: {
      subscription: 'Подписки',
      included: 'Состав',
      expires: 'Активно до',
      bought: 'Куплено',
      owned: 'Мои покупки',
      subscription_period_end: 'День оплата',
      subscription_period_start: 'Начало подписки',
      subscription_states: {
        active: 'Активен',
        trialing: 'Пробный период',
        unpaid: 'Неактивен',
        '_': 'Неизвестно'
      },
      cancel: 'Отменить подписку',
      canceled: 'Отменено',
      first_payment: 'Начало подписки',
      details: 'Подробнее',
      status: 'Статус',
      are_you_sure: 'Вы уверены?',
      cancel_desc: 'что хотите отменить подписку для',
      re_subscribe: 'Возобновить подписку вы сможите только по окончанию текущего периода.',
      yes: 'Да',
      no: 'Нет'
    },
    packages: {
      included: 'Включает',
      expires: 'Подписка до',
      bought: 'Куплено',
      owned: 'Мои покупки'
    },
    epg_event: {
      remind_me: 'Напомнить',
      not_remind: 'Не напоминать',
      record_add: 'Добавить в Запись',
      record_remove: 'Удалить из Записи',
      schedule_remove: 'Отменить Запись'
    },
    notification: {
      remind_me: 'Напомнить',
      not_remind: 'Не напоминать',
    },
    npvr: {
      record_add: 'Добавить в Запись',
      record_remove: 'Удалить из Записи',
      schedule_remove: 'Отменить Запись'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'Оператор',
      assembly: 'Монтаж',
      actor: 'Актер',
      director: 'Режиссер',
      scenario: 'Сценарий',
      composer: 'Композитор',
      presenter: 'Ведущий',
      music_director: 'Музыкальный Режиссер',
      playback_singers: 'Закадровый исполнитель',
      _: 'Другое'
    },
    offers: {
      type: {
        'free': 'Бесплатно',
        'transactional-own': 'Купить',
        'transactional-rent': 'На прокат',
        'subscription': 'Подписатьса',
        'transactional-own-bundle': 'Купить подписку',
        'transactional-rent-bundle': 'Взять на прокат по подписке',
        'subscription-bundle': 'Подписаться на подписку',
        '_': 'Другое'
      },
      pay_as_you_go: 'Предложения о покупке',
      select_bundle: 'Выбрать подписку',
      or: 'или',
      free_trial: 'Пробный период',
      free_trial_description: 'По окончанию пробного периода с вашего баланса будет списана абонентская плата',
      unit: {
        hour: 'Час',
        day: 'День',
        week: 'Неделя',
        month: 'Месяц',
        year: 'Год',
      }
    }
  },
  player: {
    no_signal: 'Нет сигнала',
    reload: 'Перезагрузить',
    youtube_connection_error: 'Ошибка подключения к Youtube'
  },
  more_menu_items: 'Еще',
  empty_section: 'В данном разделе пусто',
  empty_result: 'Нет результатов.',
  epg: {
    no_data: 'Нет данных.',
    now: 'Сейчас',
    today: 'Сегодня'
  },
  npvr: {
    filters: {
      status: 'Сортировать по статусу',
      date: 'Сортировать по дате',
      alphabet: 'Сортировать по названию',
      channel: 'Сортировать по каналу'
    },
    status: {
      pending: 'В очереди',
      scheduled: 'Запланировано',
      recording: 'В процессе',
      finished: 'Записано',
      failed: 'Ошибка',
      cancelled: 'Отменено'
    }
  },
  genres: 'Жанры',
  messages: {
    pin: {
      title: 'Введите ПИН-код',
      ok: 'Ok',
      cancel: 'Отмена'
    },
    notification: {
      title: 'Напоминание ',
      on_channel: 'на канале',
      is_switch_show_right_now: 'начнется через 5 минут. Хотите переключиться сейчас?'
    },
    share_request: {
      title: 'Поделиться ',
      vod: 'видео',
      live: 'канал',
      you_have_received: 'Вы получили оповещение ',
      sharing_notification: '. Вы хотите его посмотреть?'
    },
    bookmark: {
      title: 'Продожить просмотр?',
      continue_from: 'Продолжить с',
      start_over: 'Начать с начала'
    }
  },
  settings: {
    settings: 'Настройки',
    tabs: {
      login: {
        title: 'Авторизация',
        email: 'Номер телефона',
        password: 'Пароль',
        sign_in: 'Войти',
        error: 'Неверный логин или пароль',
        success: 'Добро пожаловать!'
      },
      registration: {
        title: 'Регистрация',
        email: 'Номер телефона',
        password: 'Пароль',
        password2: 'Подтвердите пароль',
        first_name: 'Имя',
        last_name: 'Фамилия',
        sign_up: 'Зарегистрироваться',
        code: 'Код подтверждения',
        success: "Спасибо за регистрацию!",
        need_confirmation: "Пожалуйста, подтвердите вашу регистрацию перейдя по ссылке отправленной на ваш еmail адрес.",
      },
      registration_confirm: {
        success: "Спасибо за регистрацию. Вы можете использовать ваш логин и пароль на других устройствах если данная услуга подключена."
      },
      language: {
        title: 'Язык',
        select_language: 'Выбор языка:'
      },
      parental_control: {
        title: 'Родительский контроль',
        description: 'Включить родительский контроль',
        on: 'Вкл',
        off: 'Выкл'
      },
      change_password: {
        title: 'Сменить пароль',
        save: 'Сохранить',
        old_password: 'Текущий пароль',
        new_password: 'Новый пароль',
        new_password2: 'Подтвердите пароль',
        success: 'Пароль успешно обновлен'
      },
      reset_password: {
        title: 'Сбросить пароль',
        save: 'Сохранить',
        enter_new_password: 'Введите новый пароль',
        ack: 'Код подтверждения',
        password: 'Новый пароль',
        success: 'Пароль успешно обновлен'
      },
    },
  },
  toast: {
    type: {
      record: 'Запись',
      favorite: 'Избранное',
      notification: 'Оповещения',
      purchase: 'Покупки',
      service: 'Сервисы',
      cookies: 'Файлы Cookie',
      adblock: 'Ad block'
    },
    operation: {
      record_add_success: 'Успешная постановка на запись',
      record_add_fail: 'Постановка на запись не удалась',
      record_remove_success: 'Успешная отмена записи.',
      record_remove_fail: 'Отмена записи не удалась.',
      favorite_add_success: 'Успешно добавлен',
      favorite_add_fail: 'Ошибка при добавлении',
      favorite_remove_success: 'Успешно удален.',
      favorite_remove_fail: 'Ошибка при удалении',
      notification_add_success: 'Успешно добавлено',
      notification_add_fail: 'Ошибка при добавлении',
      notification_remove_success: 'Успешно удалено',
      notification_remove_fail: 'Ошибка при удалении',
      purchase_add_success: 'Операция завершена успешно',
      purchase_add_fail: 'Ошибка в операции',
      purchase_remove_success: 'Операция завершена успешно',
      purchase_remove_fail: 'Ошибка в операции',
      service_unstable_connection: 'Связь с сервером не стабильна.',
      enable_cookies: 'Пожалуйста, включите поддержку файлов cookie',
      disable_adblock: 'Ad block может повлиять на функциональность сайта. ' +
      'Пожалуйста, добавьте нас в исключения Ad block.'
    }
  }

};

export default ru_NAR;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/nar/ru_NAR.js